import { ViewController } from 'elc-service';
import { Shade } from '../domain/entities/Shade';
import { SHADE_PICKER_TYPE } from '../constants/ShadePickerType';
import { SHADE_INFO_POSITION_TYPE } from '../constants/ShadeInfoPositionType';
import { PERFECT_SHADE_CIRCLE_COUNT, SHADE_CIRCLE_COUNT } from '../constants/ProductShadePicker';
import {
    IShadePickerController,
    ICarouselSettings,
    IShadeSwatches
} from '../interfaces/IShadePicker';
import { Breakpoints } from 'elc-base-theme';

export class ProductShadePickerViewController extends ViewController {
    private shades: Shade[] = [];
    private perfectShades: Shade[] = [];
    private shadeSwatchesConfig: IShadeSwatches = {};
    private isPerfectShadeEnabled: boolean = false;

    public initialize = (config: IShadePickerController) => {
        this.shades = config.shades;
        this.perfectShades = config.perfectShades || [];
        this.isPerfectShadeEnabled = Boolean(config.isPerfectShadeEnabled);
        this.shadeSwatchesConfig = config.shadeSwatchesConfig || {};
    };

    public get filteredShades(): Shade[] {
        return this.isPerfectShadeEnabled && this.perfectShades.length
            ? this.perfectShades
            : this.shades;
    }

    public get hasColorFamily(): boolean {
        return this.shades.some(shade => !!shade.colorFamily);
    }

    public get hasMultipleShades(): boolean {
        return this.shades.length > 1;
    }

    public get hasSomeInsideShadeCircle(): boolean {
        return this.shades.some(shade => shade.showNameInsideShadeCircle);
    }

    public get slideCount(): number {
        return this.hasSomeInsideShadeCircle ? PERFECT_SHADE_CIRCLE_COUNT : SHADE_CIRCLE_COUNT;
    }

    public get responsiveCarouselSettings(): ICarouselSettings {
        return {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            responsive: [
                {
                    breakpoint: Breakpoints.desktop,
                    settings: {
                        slidesToShow: this.slideCount,
                        slidesToScroll: this.slideCount
                    }
                }
            ],
            lazyLoad: true,
            ...this.shadeSwatchesConfig.carousel
        };
    }

    public get isShadeSwatchesTypeCarousel(): boolean {
        return this.shadeSwatchesConfig.type === SHADE_PICKER_TYPE.CAROUSEL;
    }

    public get isShadeSwatchesTypeGrid(): boolean {
        return this.shadeSwatchesConfig.type === SHADE_PICKER_TYPE.GRID;
    }

    public get shadeSwatchesSettings() {
        return this.shadeSwatchesConfig || {};
    }

    public get shadeNamePosition() {
        return this.shadeSwatchesSettings.shadeName;
    }

    public get isShadeInfoAbovePicker(): boolean {
        return this.shadeNamePosition === SHADE_INFO_POSITION_TYPE.ABOVE;
    }

    public get isShadeInfoBelowPicker(): boolean {
        return this.shadeNamePosition === SHADE_INFO_POSITION_TYPE.BELOW;
    }

    public get isShadeInfoInline(): boolean {
        return this.shadeNamePosition === SHADE_INFO_POSITION_TYPE.INLINE;
    }

    public get shadeDescriptionPosition() {
        return this.shadeSwatchesSettings.shadeDescription;
    }
}
